import I18n from "shared/i18n"

// flash-notifications captures its configuration object the first time its own
// module is evaluated, so every pack that can reach the package imports this
// module once, ahead of the first package import — otherwise the notification
// titles and the modal dismiss label fall back to the package's English
// defaults for that whole bundle.
globalThis.flashNotificationsConfiguration ||= {
  debug: false,
  translate: (msgId, args) => I18n.t(msgId, args)
}
